const RELEASE = 'release'
const BUILD = 'build'

export default Object.freeze({
    RELEASE,
    BUILD,
})
